import { Component, computed, inject } from '@angular/core';
import { AuthService, EUserRole } from 'src/app/core';
import { AppStore } from '../../state';
import { StringHelper } from '../../helpers';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-profile-preview',
  templateUrl: './profile-preview.component.html',
  styleUrls: ['./profile-preview.component.scss'],
})
export class ProfilePreviewComponent {
  private _auth: AuthService = inject(AuthService);
  protected readonly appStore: AppStore = inject(AppStore);

  public firstLetter = StringHelper.firstLetter;
  public readonly EUserRole = EUserRole;

  public userRole = computed(() => {
    return this.appStore.$user().role;
  });

  public get user() {
    return this._auth.azureUser;
  }

  public logout() {
    this._auth.logout().pipe(untilDestroyed(this)).subscribe();
  }
}
